import { render, staticRenderFns } from "./four.vue?vue&type=template&id=b41af9fe&scoped=true&"
import script from "./four.vue?vue&type=script&lang=js&"
export * from "./four.vue?vue&type=script&lang=js&"
import style0 from "./four.vue?vue&type=style&index=0&id=b41af9fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41af9fe",
  null
  
)

export default component.exports